import React, { Component } from 'react';
import Button from '@mui/material/Button';
import ContentSave from '@mui/icons-material/Save';
import SendIcon from '@mui/icons-material/Send';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import CancelIcon from '@mui/icons-material/Cancel';
import RemoveIcon from '@mui/icons-material/Remove';
import PlaceIcon from '@mui/icons-material/Place';
import EditIcon from '@mui/icons-material/Edit';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import RestoreIcon from '@mui/icons-material/Restore';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import IconButton from '@mui/material/IconButton';
import PrintIcon from '@mui/icons-material/Print';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PeopleIcon from '@mui/icons-material/People';
import SmokingRooms from '@mui/icons-material/SmokingRooms';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import Icon from '@mui/material/Icon';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Add as AddIcon, Archive as ArchiveIcon, ArrowBackIos as ArrowBackIosIcon } from '@mui/icons-material';
import SmokingRoomsIcon from '@mui/icons-material/SmokingRooms';
// import { ArrowBackIosNewIcon } from '@mui/icons-material';

class CustomButton extends Component {

    constructor(props) {
        super(props);

        this.state = {
            black: true
        }
    }

    changeColor() {
        this.setState({ black: !this.state.black })
    }

    render() {
        const p = this.props;
        let activeBtn = this.state.black ? "gray_btn" : "black_Btn";

        switch (p.type) {
            case "EditButton":
                return (
                    <Button
                        className={p.className}
                        name={p.name}
                        id={p.name || p.id}
                        variant='contained'
                        sx={{ ...p.style, ...p.buttonStyle }}
                        style={{ margin: `8px` }}
                        onClick={p.onTouchTap}
                    >{p.label}</Button>
                );
            case "dashboardButton":
                return (
                    <Button
                        className={p.className + " " + activeBtn}
                        name={p.name}
                        id={p.id}
                        onClick={() => { p.onTouchTap(); this.changeColor.bind(this) }} //Changes the button bg color when click
                        style={p.style}
                        label={p.label}
                        primary={true}
                        variant={Boolean(p.primary) ? 'contained' : Boolean(p.secondary) ? 'outlined' : "text"}>
                        {p.label}
                    </Button>
                );
            case "InactivateButton":
                return (
                    <Button name={p.name}
                        id={p.name || p.id} className={p.className} style={p.style} label={p.label} secondary={true} onClick={p.onTouchTap} />
                );
            case "ActivateButton":
                return (
                    <Button name={p.name}
                        id={p.name || p.id} className={p.className} style={p.style} label={p.label} primary={true} onClick={p.onTouchTap} />
                );
            case "IconInButton":
                return (
                    <Button
                        style={p.style}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        disabled={p.disabled}
                        sx={{ backgroundColor: p.backgroundColor || "#6C59B9", color: "#ffffff" }}
                        onClick={p.onTouchTap}
                        variant='contained'
                        startIcon={p.icon}
                    >
                        {p.label}
                    </Button>
                );
            case "FloatButton":
                return (
                    <Button
                        name={p.name}
                        id={p.name || p.id}
                        variant='contained'
                        style={p.style}
                        fullWidth={p.fullWidth}
                        labelColor="#FFFFFF"
                        labelPosition="after"
                        onClick={p.onTouchTap}
                        className={p.className}
                        backgroundColor={"#4F0675"}
                        startIcon={<AddIcon />}
                    >
                        {p.label || p.hintText}
                    </Button>
                );
            case "RaisedButton":
                return (
                    <Button
                        name={p.name}
                        id={p.name || p.id}
                        sx={{ ...p.buttonStyle, backgroundColor: p.backgroundColor }}
                        fullWidth={p.fullWidth}
                        onClick={p.onTouchTap}
                        className={p.className}
                        disabled={p.disabled}
                        color={p.secondary ? "secondary" : "primary"}
                        variant="contained"
                    >
                        {p.label}
                    </Button>
                );
            case "IconButton":
                return (

                    <IconButton tooltip={p.tooltip}
                        onClick={p.onTouchTap}
                        label={p.label}
                        className={p.newClass || p.className}
                        disabled={p.disabled}
                        id={p.name || p.id}
                    >
                        {p.icon}

                    </IconButton>

                );
            case "IconRemoveButton":
                return (

                    <IconButton tooltip={p.tooltip}
                        onClick={p.onTouchTap}
                        label={p.label}
                        className={`${p.newClass || p.className} redIcon`}
                        disabled={p.disabled}
                    >
                        <CancelIcon />
                    </IconButton>

                );
            case "IconCheckButton":
                return (
                    <IconButton tooltip={p.tooltip}
                        onClick={p.onTouchTap}
                        label={p.label}
                        className={`${p.newClass || p.className}`}
                        disabled={p.disabled}
                        onInvalidCapture={p.id}
                    >
                        <CheckCircleIcon />
                    </IconButton>

                );
            case "IconQueue":
                return (
                    <IconButton className={p.className}
                        disabled={p.disabled}
                        name={p.name}
                        id={p.name || p.id}
                        style={p.style}
                        onClick={p.onTouchTap}>
                        <SocialPeople />
                    </IconButton>
                );
            case "IconRemove":
                return (
                    <div>
                        <IconButton tooltip={p.tooltip}
                            onClick={p.onTouchTap}
                            label={p.label}
                            className={p.newClass}
                            disabled={p.disabled}
                        >
                            {p.icon}
                        </IconButton>
                        <p>{p.label}</p>
                    </div>
                );
            case "IconEditButton":
                return (
                    <IconButton className={p.className}
                        name={p.name}
                        id={p.name || p.id}
                        disabled={p.disabled}
                        style={p.style}
                        onClick={p.onTouchTap}>
                        <EditIcon />
                    </IconButton>
                );
            case "IconViewButton":
                return (
                    <IconButton className={p.className}
                        name={p.name}
                        id={p.name || p.id}
                        disabled={p.disabled}
                        style={p.style}
                        onClick={p.onTouchTap}>
                        <VisibilityIcon />
                    </IconButton>
                );
            case "PasswordButton":
                return (
                    <IconButton className={p.className}
                        name={p.name}
                        id={p.name || p.id}
                        disabled={p.disabled}
                        style={p.style}
                        onTouchTap={p.onTouchTap}>
                        <VpnKeyIcon />
                    </IconButton>
                );
            case "IconAddPerson":
                return (
                    <IconButton className={p.className}
                        name={p.name}
                        id={p.name || p.id}
                        disabled={p.disabled}
                        style={p.style}
                        onTouchTap={p.onTouchTap}
                        tooltip="Add">
                        <PersonAddIcon />
                    </IconButton>
                );
            case "IconClearButton2":
                return (
                    // <IconButton tooltip={p.tooltip}
                    //     onClick={p.onTouchTap}
                    //     label={p.label}
                    //     className={p.label && "IconsSearch"}
                    //     labelPosition="after">
                    //     <Icon className="glyphicon glyphicon-refresh" />
                    //     <p>Clear</p>
                    // </IconButton>
                    <Tooltip title={p.tooltip}>
                        <IconButton onClick={p.onTouchTap} name={p.name}
                            id={p.name || p.id} className={p.label ? "IconsSearch" : ""}>
                            <RefreshIcon />
                            {p.label && <p style={{ marginLeft: 8 }}>{p.label}</p>}
                        </IconButton>
                    </Tooltip>
                );
            case "IconClearButton":
                return (
                    // <Button
                    //     style={p.style}
                    //     className={p.className}
                    //     labelStyle={p.labelStyle}
                    //     labelColor="#616161"
                    //     label={p.label}
                    //     disabled={p.disabled}
                    //     labelPosition="after"
                    //     backgroundColor={p.backgroundColor || "#f2f2f2"}
                    //     onClick={p.onTouchTap}
                    //     icon={<RestoreIcon />}
                    // />
                    <Button
                        style={{ backgroundColor: p.backgroundColor || "#f2f2f2", ...p.style }}
                        name={p.name}
                        id={p.id}
                        className={p.className}
                        disabled={p.disabled}
                        onClick={p.onTouchTap}
                        startIcon={<RestoreIcon />}
                    // startIcon={p.labelPosition === "before" ? <RestoreIcon /> : null}
                    // endIcon={p.labelPosition === "after" ? <RestoreIcon /> : null}
                    >
                        <span style={p.labelStyle}>{p.label}</span>
                    </Button>
                );
            case "IconClearWarehouseButton":
                return (
                    <Button
                        style={p.style}
                        className={p.className}
                        name={p.name}
                        id={p.name || p.id}
                        labelStyle={p.labelStyle}
                        labelColor="#616161"
                        label="Clear Hold"
                        disabled={p.disabled}
                        labelPosition="after"
                        backgroundColor={p.backgroundColor || "#f2f2f2"}
                        onClick={p.onTouchTap}
                        icon={<RestoreIcon />}
                    />
                );
            case "IconSearchButton2":
                return (
                    <IconButton tooltip={p.tooltip}
                        onClick={p.onTouchTap}
                        label={p.label}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.label && "IconsSearch"}
                        labelPosition="after">
                        <Icon className="glyphicon glyphicon-search" />
                        <p>Search</p>
                    </IconButton>
                );
            case "IconSearchButton":
                return (
                    // <Button
                    //     style={p.style}
                    //     className={p.className}
                    //     labelStyle={p.labelStyle}
                    //     labelColor="#FFFFFF"
                    //     label="Search"
                    //     disabled={p.disabled}
                    //     labelPosition="after"
                    //     backgroundColor={p.backgroundColor || "#1586CC"}
                    //     onClick={p.onTouchTap}
                    //     icon={<SearchIcon />}

                    // />
                    <Button
                        // style={{ backgroundColor: p.backgroundColor || "#1586CC", ...p.style }}
                        className={p.className}
                        name={p.name}
                        id={p.name || p.id}
                        disabled={p.disabled}
                        variant="contained"
                        onClick={p.onTouchTap}
                        startIcon={p.labelPosition === "before" ? <SearchIcon /> : null}
                        endIcon={p.labelPosition === "after" ? <SearchIcon /> : null}
                        sx={{ backgroundColor: p.backgroundColor || p.backgroundColor }}
                    >
                        <span style={p.labelStyle}>Search</span>
                    </Button>
                );
            case "IconSearchButtonLabel":
                return (
                    <Button
                        style={p.style}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        label={p.label}
                        disabled={p.disabled}
                        labelPosition="after"
                        onClick={p.onTouchTap}
                        startIcon={<SearchIcon />}
                    >
                        <p>{p.label}</p>
                    </Button>
                );
            case "IconTransferButton":
                return (
                    <Button
                        style={p.style}
                        name={p.name}
                        id={p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        label="Transfer"
                        disabled={p.disabled}
                        sx={{ backgroundColor: p.backgroundColor || "#1586CC", color: "#ffffff" }}
                        onClick={p.onTouchTap}
                        startIcon={<SwapHorizIcon />}
                    >
                        Transfer
                    </Button>
                );
            case "IconSettingsButton":
                return (
                    <Button
                        style={p.style}
                        name={p.name}
                        id={p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        disabled={p.disabled}
                        sx={{ backgroundColor: p.backgroundColor || "#F2AF2A", color: "#ffffff" }}
                        onClick={p.onTouchTap}
                        startIcon={<SettingsIcon />}
                    >Adjust</Button>
                );
            case "IconSettingsButtonNoIcon":
                return (
                    <Button
                        style={p.style}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        label="Adjust"
                        disabled={p.disabled}
                        labelPosition={p.labelPosition || "after"}
                        backgroundColor={p.backgroundColor || "#F2AF2A"}
                        onClick={p.onTouchTap}
                    />
                );
            case "BulkToUnitButton":
                return (
                    <Button
                        style={{ fontSize: "10px" }}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        label="Bulk-Unit"
                        disabled={p.disabled}
                        labelPosition="after"
                        backgroundColor={p.backgroundColor || "#39B54F"}
                        onClick={p.onTouchTap}
                        icon={<SmokingRooms />}
                    >
                        Bulk-Unit
                    </Button>
                );
            case "WpUploadButton":
                return (
                    <Button
                        style={{ fontSize: "10px" }}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        label="WP Inventory Update"
                        disabled={p.disabled}
                        labelPosition="after"
                        backgroundColor={p.backgroundColor || "#39B54F"}
                        onClick={p.onTouchTap}
                        // icon={<PlacesSmokingRooms />}
                        startIcon={<SmokingRoomsIcon />}
                    >
                        WP Inventory Update
                    </Button>
                );
            case "LookupUnmappedProducts":
                return (
                    <Button
                        style={{ fontSize: "10px" }}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        label="Lookup for missing products"
                        disabled={p.disabled}
                        labelPosition="after"
                        backgroundColor={p.backgroundColor || "#39B54F"}
                        onClick={p.onTouchTap}
                    // icon={<PlacesSmokingRooms />}
                    />
                );
            case "IconJointButton":
                return (
                    <Button
                        style={{ fontSize: "10px" }}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        label="Roll Joint"
                        disabled={p.disabled}
                        labelPosition="after"
                        backgroundColor={p.backgroundColor || "#39B54A"}
                        onClick={p.onTouchTap}
                        // icon={<PlacesSmokingRooms />}
                    />
                );
            case "ArrowDown":
                return (
                    <IconButton className={p.className}
                        name={p.name}
                        id={p.name || p.id}
                        disabled={p.disabled}
                        style={p.style}
                        onClick={p.onTouchTap}
                    >
                        <KeyboardArrowDown />
                    </IconButton>
                );
            case "ArrowUp":
                return (
                    <IconButton className={p.className}
                        name={p.name}
                        id={p.name || p.id}
                        disabled={p.disabled}
                        style={p.style}
                        onClick={p.onTouchTap}
                    >
                        <KeyboardArrowUp />
                    </IconButton>
                );
            case "FloatRemoveButton":
                return (
                    <FloatingActionButton name={p.name}
                        id={p.name || p.id} className={p.className} disabled={p.disabled} mini={p.mini} style={p.style} onClick={p.onTouchTap} secondary={true} >
                        <RemoveIcon />
                    </FloatingActionButton>
                );
            case "FloatAddButton":
                return (
                    <FloatingActionButton name={p.name}
                        id={p.name || p.id} className={p.className} disabled={p.disabled} mini={p.mini} style={p.style} onClick={p.onTouchTap} secondary={p.secondary}  >
                        {/* <AddIcon /> */}
                    </FloatingActionButton>
                );
            case "AddButton":
                return (
                    <Button
                        sx={{
                            ...p.style,
                            color: '#FFFFFF',
                        }}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        variant="contained"
                        disabled={p.disabled}
                        onClick={p.onTouchTap}
                        startIcon={<AddIcon />}
                    >
                        {p.label}
                    </Button>

                );
            case "SendButton":
                return (
                    <Button
                        name={p.name}
                        id={p.name || p.id}
                        onClick={p.onTouchTap}
                        style={p.style}
                        className={p.className}
                        labelColor="#FFFFFF"
                        labelStyle={p.labelStyle}
                        label={p.label}
                        primary={true}
                        labelPosition="after"
                        icon={<SendIcon />}
                    >{p.label}
                    </Button>
                );
            case "SaveButton":
                return (
                    <Button
                        sx={{ ...p.style, ...p.labelStyle }}
                        className={p.className}
                        name={p.name}
                        id={p.name || p.id}
                        labelColor="#FFFFFF"
                        variant='contained'
                        disabled={p.disabled}
                        labelPosition="after"
                        onClick={p.onTouchTap}
                        startIcon={<ContentSave />}
                    >{p.label}</Button>
                );
            case "SaveButtonNoIcon":
                return (
                    <Button
                        sx={p.style}
                        className={p.className}
                        name={p.name}
                        id={p.name || p.id}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        variant='contained'
                        label={p.label}
                        disabled={p.disabled}
                        labelPosition="after"
                        onClick={p.onTouchTap}
                    >{p.label}
                    </Button>
                );
            case "SearchButton":
                return (
                    <Button
                        style={p.style}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        buttonStyle={p.buttonStyle}
                        variant='contained'
                        label={p.label}
                        disabled={p.disabled}
                        labelPosition="after"
                        onClick={p.onTouchTap}
                        startIcon={<SearchIcon />}
                    > {p.label}
                    </Button>
                );
            case "IconTextButton":
                return (
                    <IconButton tooltip={p.tooltip}
                        name={p.name}
                        id={p.name || p.id}
                        onTouchTap={p.onTouchTap}
                        label={p.label}
                        className={p.newClass}
                        labelPosition="after">
                        <Icon className={p.className} />
                        <p>{p.name}</p>
                    </IconButton>
                );
            case "OptionsButton":
                return (
                    <Button
                        style={p.style}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        primary={true}
                        label={p.label}
                        disabled={p.disabled}
                        labelPosition="after"
                        onClick={p.onTouchTap}
                        icon={<ActionSettings />}
                    ><ActionSettings /> {p.label}
                    </Button>
                );
            case "GiftCardButton":
                return (
                    <Button
                        style={p.style}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        primary={true}
                        label={p.label}
                        disabled={p.disabled}
                        labelPosition="after"
                        onClick={p.onTouchTap}
                        icon={<CardGiftcardIcon />}
                    >
                        <CardGiftcardIcon />
                        {p.label}
                    </Button>
                )
            case "ImportExportButton":
                return (
                    <Button
                        style={p.style}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        buttonStyle={p.buttonStyle}
                        variant="contained"
                        disabled={p.disabled}
                        labelPosition="after"
                        onClick={p.onTouchTap}
                        startIcon={<ImportExportIcon />}
                    >{p.label}
                    </Button>
                )
            case "PrintButton":
                return (
                    <Button variant="text" color="primary"
                        name={p.name}
                        id={p.name || p.id}
                        onClick={p.onTouchTap}
                        label={p.label}
                        className={p.className}
                    ><PrintIcon />{p.label}
                    </Button>
                );
            case "SendEmailButton":
                return (
                    <Button variant="text" color="primary"
                        name={p.name}
                        id={p.name || p.id}
                        style={p.style}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        label={p.label}
                        disabled={p.disabled}
                        onClick={p.onTouchTap}
                    ><SendIcon /> {p.label}
                    </Button>
                );
            case "SaveToPDFButton":
                return (
                    <Button variant="text" color="primary"
                        name={p.name}
                        id={p.name || p.id}
                        onClick={p.onTouchTap}
                        label={p.label}
                        className={p.className}
                    ><ContentSave />{p.label}
                    </Button>
                );
            case "CheckIn":
                return (
                    <Button
                        style={p.style}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        primary={true}
                        label={p.label}
                        disabled={p.disabled}
                        labelPosition="after"
                        onClick={p.onTouchTap}

                    ><PlaceIcon /> {p.label}
                    </Button>
                );
            case "IconAddButton":
                return (
                    <Button
                        style={p.style}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        label="Add"
                        disabled={p.disabled}
                        labelPosition="after"
                        backgroundColor={p.backgroundColor || "#42bf3e"}
                        onClick={p.onTouchTap}
                    >
                        <AddIcon />
                        {p.label || "Add"}
                    </Button>
                );
            case "IconAdd":
                return (
                    <Button
                        style={p.style}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        label="Add"
                        disabled={p.disabled}
                        labelPosition="after"
                        backgroundColor={p.backgroundColor || "#42bf3e"}
                        onClick={p.onTouchTap}
                    >
                        <AddIcon />
                    </Button>
                );
            case "IconDeleteButton":
                return (
                    <Button
                        style={p.style}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        label={p.label}
                        disabled={p.disabled}
                        labelPosition="after"
                        backgroundColor={p.backgroundColor || "#c71515"}
                        onClick={p.onTouchTap}
                    ><DeleteIcon /> {p.label}
                    </Button>


                );
            case "IconDelete":
                return (
                    <IconButton
                        style={p.style}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        labelStyle={p.labelStyle}
                        labelColor="#FFFFFF"
                        label={p.label}
                        disabled={p.disabled}
                        labelPosition="after"
                        backgroundColor={p.backgroundColor || "#c71515"}
                        onClick={p.onTouchTap}
                    ><DeleteIcon />
                    </IconButton>
                );
            case "CancelButton":
                return (
                    p.primary ? <Button variant="text" color="primary" id={p.name || p.id} className={`btnCancel ${p.className}`} primary={true} onClick={p.onTouchTap} >{p.label}</Button>
                        : p.secondary ? <Button variant="text" color="primary" id={p.name || p.id} className={`btnCancel ${p.className}`} secondary={true} onClick={p.onTouchTap} >{p.label}</Button>
                            : <Button variant="text" color="primary" id={p.name || p.id} className={`btnCancel ${p.className}`} onClick={p.onTouchTap} >{p.label}</Button>
                );
            case "FlatButtonPrimary":
                return (
                    <Button variant="text" color="primary" className={p.className} name={p.name}
                        id={p.name || p.id}
                        disabled={p.disabled}
                        style={p.style}
                        backgroundColor={p.primary === true ? "#551073" : "#f5f5f5"} fullWidth={p.fullWidth} primary={true} onClick={p.onTouchTap} >{p.label}</Button>
                );
            // case "FlatButtonPrimaryDarker":
            //     return (
            //         <FlatButton className={p.className} backgroundColor={p.primary === true ? "#551073" : "#e6e6e6"} fullWidth={p.fullWidth} primary={true} label={p.label} onTouchTap={p.onTouchTap} />
            //     );
            case "FlatButtonSecondary":
                return (
                    <Button name={p.name}
                        id={p.name || p.id} variant="text" color="primary" className={p.className} secondary={true} label={p.label} onTouchTap={p.onTouchTap} />
                );
            case "AddMember":
                return (
                    <Button name={p.name}
                        id={p.name || p.id} variant="text" color="primary"
                        onClick={p.onTouchTap}
                        className="pull-right"
                        primary={true}
                    ><AddIcon /> {p.label}
                    </Button>
                );
            case "HeaderBackPage":
                return (
                    <Button name={p.name}
                        id={p.name || p.id} onClick={p.onTouchTap} variant="text" color="primary"
                        className="btn-go-back"
                        startIcon={<ArrowBackIosIcon />}
                    >
                        Go Back
                    </Button>
                );

            // New Buttons (added React 18) - remove this comment once the button component is arranged
            case "DownloadButton":
                return (
                    <Button
                        style={p.style}
                        name={p.name}
                        id={p.name || p.id}
                        className={p.className}
                        disabled={p.disabled}
                        sx={{ backgroundColor: p.backgroundColor || "#6C59B9", color: "#ffffff" }}
                        onClick={p.onTouchTap}
                        variant='contained'
                        startIcon={<ArchiveIcon />}
                    >
                        {p.label}
                    </Button>
                )
            default:
                return (
                    <Button className={p.className || ''}
                        name={p.name}
                        id={p.name || p.id}
                        variant={p.primary ? 'contained' : p.secondary ? 'outlined' : "text"}
                        disabled={p.disabled}
                        sx={{ ...p.sx || p.style }}
                        onClick={p.onTouchTap}
                        href={p.href}
                        target={p.target}
                        download={p.download}>
                        {p.label}
                        {p.children}
                    </Button>
                );
        }
    }
}

export default CustomButton;
